<mat-card fullscreen style="background-color: #dbd3be;" class="fgtpwd"  >



     <mat-card style="background-color: #f7f4ea;">
        <div class="row">
        <div class="col-sm-12 col-mat-6 col-xl-6 col-xl-6"  style="color:#000;font-size:30px;font-family: open-sans">
            <img src="assets/images/logo.png" style="    width: 60%;">

    </div>
    <div class="col-sm-12 col-mat-6 col-xl-6 col-xl-6"  style="color:#000;font-size:30px;font-family: open-sans">
    <form [formGroup]="forgotpassform" (ngSubmit)="postForgotpass(f)" #f="ngForm">

      <div class="form-group" class="wrap-inputlogin form-group" style="margin-top:25px;">
        <label style="font-size:20px;" for="email">Your Registered Email id:</label>
      <input placeholder="Enter your Email id" type="email" name="email" id="email" class="inputlogin form-control" [(ngModel)]="forgotpassform.email" class="form-control" formControlName="email" required>

      </div>

      <div  *ngIf="( forgotpassform.get('email').hasError('required') || forgotpassform.get('email').hasError('pattern') ) && forgotpassform.get('email').touched">

        <div class="error" style="color:red;font-size:20px"  *ngIf="forgotpassform.get('email').hasError('required') && forgotpassform.get('email').touched">
        Email id is required
        </div>
        <div class="error" style="color:red;font-size:20px" *ngIf="forgotpassform.get('email').hasError('pattern') && forgotpassform.get('email').touched">
        This is not a valid Email id
        </div>

      </div>
    <div>
        <button type="submit" class="btn btn-success2; btn login"  [disabled]="!forgotpassform.valid" >Reset Password</button><br>
    </div>

    <div class="error" style="color:#9b7544;font-size:20px; margin-top: -10px"  *ngIf="flag1 == 1">
   Your Password was reset and the new password is successfully sent to your email. Please check your mail and login with the new password.
        </div>

        <div *ngIf="flag1 == 1">
            <button  class= "btn btn-success2" routerLink="/signin">Click here to Sign In </button>
          </div>

        <div class="error" style="color:red;font-size:20px; margin-top: -10px"  *ngIf="flag1 == 2">
    This email id is not registered with us. Please enter the correct email id used to register with us.
                 </div>

    </form>
  </div>
        </div>

    </mat-card>

    </mat-card>
